import {
  Container,
  Title,
  Text,
  List,
  Divider,
  Space,
  Paper,
} from "@mantine/core";
import { Link } from "react-router-dom";
import { AppName, ContactInformation, LogoFull } from "../../Lib/Data";

import "./styles.scss";

export default function TermsAndConditions() {
  document.title = `Terms and Conditions | ${AppName}`;

  return (
    <Container size="md" py="xl" className="terms-and-conditions-container">
      <div className="flex-row align-center justify-center width-100">
        <Link to="/">
          <img className="logo pointer" src={LogoFull} alt="" />
        </Link>
      </div>
      <Paper withBorder p={40} radius="lg" mt="xl" shadow="sm">
        <Title order={2} mb="md">
          Terms and Conditions
        </Title>

        <Text mb="md">
          Welcome to {AppName}! These Terms and Conditions ("Terms", "Terms and
          Conditions") govern your use of our service. By accessing or using the
          service you agree to be bound by these Terms.
        </Text>

        <Divider my="lg" />

        <Title order={3} mb="sm">
          1. Introduction
        </Title>
        <Text mb="md">
          {AppName} provides users with access to discounted subscription plans
          for various digital services through family and group sharing options.
          By using {AppName}, you confirm that you are legally capable of
          entering into binding contracts and that you accept these Terms.
        </Text>

        <Title order={3} mb="sm">
          2. User Accounts
        </Title>
        <List spacing="sm" mb="sm" listStyleType="disc" withPadding>
          <List.Item>
            You must create an account to access most features.
          </List.Item>
          <List.Item>
            You are responsible for maintaining the confidentiality of your
            account and password.
          </List.Item>
          <List.Item>
            Providing false information may result in account termination.
          </List.Item>
        </List>

        <Title order={3} mb="sm">
          3. Service Use
        </Title>
        <Text mb="md">
          Our service allows users to join or manage shared subscription plans.
          You agree to use our service only for lawful purposes and in
          accordance with these Terms. You may not use our service for any
          illegal or unauthorized purposes.
        </Text>

        <Title order={3} mb="sm">
          4. Payments and Billing
        </Title>
        <List spacing="sm" mb="sm" listStyleType="disc" withPadding>
          <List.Item>
            All payments are processed securely through third-party providers.
          </List.Item>
          <List.Item>
            Fees are non-refundable once a subscription period begins unless
            otherwise stated.
          </List.Item>
          <List.Item>
            You agree to provide current, complete, and accurate purchase
            information.
          </List.Item>
        </List>

        <Title order={3} mb="sm">
          5. User Conduct
        </Title>
        <List mb="sm" spacing="sm" listStyleType="disc" withPadding>
          <List.Item>
            No impersonation of other individuals or entities.
          </List.Item>
          <List.Item>
            No unauthorized use of payment information or accounts.
          </List.Item>
          <List.Item>
            No transmitting of viruses or other malicious code.
          </List.Item>
        </List>

        <Title order={3} mb="sm">
          6. Intellectual Property
        </Title>
        <Text mb="md">
          All content provided by {AppName}, including but not limited to text,
          graphics, logos, and software, is the property of {AppName} or its
          licensors and is protected by copyright and other laws.
        </Text>

        <Title order={3} mb="sm">
          7. Changes to Service
        </Title>
        <Text mb="md">
          We reserve the right to withdraw or amend our service, and any service
          or material we provide, in our sole discretion without notice. We will
          not be liable if for any reason all or any part of the service is
          unavailable at any time.
        </Text>

        <Title order={3} mb="sm">
          8. Login Information Sharing
        </Title>
        <Text mb="md">
          We DO NOT permit you to share the login information of any services
          with others. If you are caught doing so, we reserve the right to
          terminate your account.
        </Text>
        <Title order={3} mb="sm">
          9. Termination
        </Title>
        <Text mb="md">
          We may terminate or suspend your account immediately, without prior
          notice, if you breach these Terms or engage in behavior that we deem
          harmful to our service or users.
        </Text>

        <Title order={3} mb="sm">
          10. Limitation of Liability
        </Title>
        <Text mb="md">
          In no event shall {AppName}, nor its directors, employees, partners,
          agents, or affiliates, be liable for any indirect, incidental,
          special, consequential, or punitive damages arising from your use of
          the service.
        </Text>

        <Title order={3} mb="sm">
          11. Indemnification
        </Title>
        <Text mb="md">
          You agree to defend, indemnify and hold harmless {AppName} from and
          against any and all claims, damages, obligations, losses, liabilities,
          costs, and expenses arising from your use of the service or your
          violation of these Terms.
        </Text>

        <Title order={3} mb="sm">
          12. Governing Law
        </Title>
        <Text mb="md">
          These Terms shall be governed and construed in accordance with the
          laws of the Federal Republic of Nigeria, without regard to its
          conflict of law provisions.
        </Text>

        <Title order={3} mb="sm">
          13. Changes to Terms
        </Title>
        <Text mb="md">
          We reserve the right to revise these Terms at any time. All changes
          are effective immediately when we post them. Your continued use of the
          service after changes are posted constitutes your acceptance of the
          new Terms.
        </Text>

        <Title order={3} mb="sm">
          14. Contact Us
        </Title>
        <Text>
          If you have any questions about these Terms, please contact us at
          {ContactInformation.email}.
        </Text>
      </Paper>
      <Space h="xl" />
    </Container>
  );
}
